import React from "react";
import {Card, Descriptions, Typography} from "antd";

const {Title, Text} = Typography;

const getUser = () => {
    try {
        return JSON.parse(localStorage.getItem("user") || sessionStorage.getItem("user") || "{}");
    } catch {
        return {};
    }
};

const AgentProfilePage = () => {
    const user = getUser();

    return (
        <div>
            <div style={{marginBottom: 16}}>
                <Title level={3} style={{marginBottom: 4}}>
                    Profile
                </Title>
                <Text type="secondary">
                    Review your account information.
                </Text>
            </div>

            <Card>
                <Descriptions column={1} bordered size="middle">
                    <Descriptions.Item label="Username">
                        {user?.username || "-"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Name">
                        {[user?.first_name, user?.last_name].filter(Boolean).join(" ") || "-"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Email">
                        {user?.email || "-"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Account Type">
                        {user?.account_type
                            ? user.account_type.charAt(0).toUpperCase() + user.account_type.slice(1)
                            : "-"}
                    </Descriptions.Item>
                </Descriptions>
            </Card>
        </div>
    );
};

export default AgentProfilePage;